import { Component, OnInit, Input, ElementRef, ViewChild } from '@angular/core';
import { VehicleSettings } from '../../model/settings.model';
import { NgbModalRef, NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { ParametersService } from '../../service/parameters.service';
import { ToastService } from '../../service/toast.service';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-parameters-vehicle',
  templateUrl: './parameters-vehicle.component.html',
  styleUrls: ['./parameters-vehicle.component.less']
})

export class ParametersVehicleComponent implements OnInit {

  @Input() vehicle: VehicleSettings;
  @Input() company: boolean;
  @ViewChild('content') content: ElementRef;
  isOpen: boolean;
  modalRef: NgbModalRef;
  closeResult: string;
  newValueClass: FormControl;

  constructor(private modalService: NgbModal,
    private readonly _parametersService: ParametersService,
    private readonly _toastService: ToastService) { }


  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  addClasse() {
    let value = this.newValueClass.value;
    if (this.vehicle.classes.findIndex(v => { return v.value === value }) === -1 && value !== '') {
      this.vehicle.classes.push({ value: value, display: this.newValueClass.value })
      this.saveVehicle();
    }
    this.newValueClass.setValue('');
  }

  delCalsse(value) {
    let index = this.vehicle.classes.findIndex(v => { return v.value === value });
    if (index !== -1 && value !== '') {
      this.vehicle.classes.splice(index, 1)
      this.saveVehicle();
    }
  }

  open() {
    this.newValueClass = new FormControl('')
    this.isOpen = true;
    this.modalRef = this.modalService.open(this.content, { backdropClass: 'backdropClassModal' });
    this.modalRef.result.then((result) => {
      this.isOpen = false;

      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.isOpen = false;
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  onChange() {
    this.saveVehicle();
  }

  saveVehicle() {
    this._toastService.toastOpen(true);
    this._parametersService.saveVehicle(this.vehicle, this.company).then(() => {
      this._toastService.toastOpen(false);
    })
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/element/parameters-vehicle/parameters-vehicle.component.ts